export var Realm;
(function (Realm) {
    Realm["Eis"] = "EIS";
    Realm["Lp"] = "LP";
})(Realm || (Realm = {}));
//# sourceMappingURL=index.js.map